import ismobilejs from 'ismobilejs';
import queryParser from 'query-string';

// 以下所有都设置为方法，不可为属性，才能在使用过程中每次都会更新结果
export default {
  /**
   * 是否在客户端里
   */
  isClient() {
    return navigator.userAgent.toLocaleLowerCase().includes('roombox');
  },

  /**
   * 判断是否是移动设备
   */
  isMobile() {
    const isMobileJs = ismobilejs();
    return isMobileJs.any;
  },

  /**
   * 判断是否是手机端
   */
  isPhone() {
    const isMobileJs = ismobilejs();
    return isMobileJs.phone;
  },

  /**
   * 判断是否是平板
  */
  isTablet() {
    const isMobileJs = ismobilejs();
    return isMobileJs.tablet || navigator.userAgent.toLocaleLowerCase().includes('pad');
  },

  /**
   * 获取当前客户端版本
  */
  getClientVersion() {
    const ua = navigator.userAgent;
    try {
      return ua.split('RoomBox/')[1].split(' ')[0];
    } catch (error) {
      return '';
    }
  },

  /**
   * 版本比较
   * @param curV 当前版本
   * @param reqV
   */
  versionCompare(curV: string, reqV: string) {
    const arr1 = curV.split('.');
    const arr2 = reqV.split('.');
    // 将两个版本号拆成数字
    const maxL = Math.max(arr1.length, arr2.length);
    let pos = 0; // 当前比较位
    let diff = 0; // 当前为位比较是否相等
    // 逐个比较如果当前位相等则继续比较下一位
    while (pos < maxL) {
      diff = (parseInt(arr1[pos], 10) || 0) - (parseInt(arr2[pos], 10) || 0);
      if (diff !== 0) break;
      pos += 1;
    }
    if (diff >= 0) { // curV >= reqV
      return true;
    } // curV < reqV
    return false;
  },

  /**
   * 判断系统
   */
  validateOS() {
    const ua = navigator.userAgent.toLocaleLowerCase();
    console.log('ua', ua);
    if (ua.indexOf('window') > 0) {
      return 'Windows';
    } if (/ipad|iphone|ipod/.test(ua)) {
      return 'iOS';
    } if (ua.indexOf('mac') > 0) {
      return 'Mac';
    } if (ua.indexOf('android') > 0) {
      return 'Android';
    } if (ua.indexOf('linux') > 0) {
      return 'Linux';
    }
    return 'NUll';
  },

  /**
   * 获取当前语言
   */
  getLanguage() {
    return this.getSearchParam()?.language || navigator.language || 'cn';
  },

  /**
   * 判断是否是永久有效
   * @param validTerm {Number} 有效天数
   */
  isPermanent(validTerm: number) {
    return validTerm >= 36500;
  },

  /**
   *  获取url参数
   */
  getSearchParam() {
    let searchParams: any;
    if (window.location.search) {
      searchParams = queryParser.parse(window.location.search);
      Object.keys(searchParams).forEach((key: string) => {
        const value = searchParams[key];
        if (value instanceof Array) {
          const uniqueArr = Array.from(new Set(value));
          if (value.length !== uniqueArr.length && uniqueArr.length === 1) {
            [searchParams[key]] = uniqueArr;
          }
        }
      });
    }
    return searchParams || {};
  },

  /**
   *  获取video截图
   */
  async getSnapShot(video: HTMLVideoElement, options?: any) {
    try {
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        ctx.restore();
        const canvasWatermark = this.drawWatermark(options, canvas.width, canvas.height) as any;
        ctx.drawImage(canvasWatermark, 0, 0, canvas.width, canvas.height);
      }
      const blob: any = await this.canvasToBlob(canvas);
      canvas.remove();
      return blob;
    } catch (error) {
      console.log('getSnapShot error', error);
    }
  },

  /**
   *  获取水印截图
   */
  drawWatermark(options: any, width: number, height: number) {
    if (!options) {
      return;
    }
    const fontSize = 14;
    const color = 'rgba(0, 0, 0, 0.15)';
    const strokeColor = 'rgba(255, 255, 255, 0.15)';
    const rotate = -30;
    const canvasObj = document.createElement('canvas');
    const canvas2d = canvasObj.getContext('2d') as any;
    canvasObj.width = 400;
    canvasObj.height = 200;
    canvas2d.font = `${fontSize}px Arial bold`;
    canvas2d.fillStyle = color;
    canvas2d.strokeStyle = strokeColor;
    canvas2d.translate(canvasObj.width / 4, canvasObj.height / 2);
    canvas2d.rotate((rotate / 180) * Math.PI);
    // canvas 文字描边
    let enableContent = true;
    if (options.name) {
      canvas2d.fillText(options.name, 0, canvasObj.height / 2);
      canvas2d.strokeText(options.name, 0, canvasObj.height / 2);
      enableContent = false;
    }
    if (options.id) {
      canvas2d.fillText(options.id, 0, canvasObj.height / 2 - 15);
      canvas2d.strokeText(options.id, 0, canvasObj.height / 2 - 15);
      enableContent = false;
    }
    if (enableContent && options.content) {
      canvas2d.fillText(options.content, 0, canvasObj.height / 2);
      canvas2d.strokeText(options.content, 0, canvasObj.height / 2);
    }
    const pattern = canvas2d.createPattern(canvasObj, 'repeat');
    const canvasWaterMark = document.createElement('canvas');
    canvasWaterMark.width = width;
    canvasWaterMark.height = height;
    const canvas2dWatermark = canvasWaterMark.getContext('2d') as any;
    canvas2dWatermark.fillStyle = pattern as CanvasPattern;
    canvas2dWatermark.fillRect(0, 0, width, height);
    return canvasWaterMark;
  },

  canvasToBlob(canvas: HTMLCanvasElement) {
    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        resolve(blob);
      }, 'image/jpeg', 0.8);
    });
  },

  /** 是否为safari浏览器（ua中只包括safari字段没有chrome字段） */
  isSafari() {
    const ua = navigator.userAgent.toLowerCase();
    return /safari/.test(ua) && !/chrome/.test(ua);
  },

  /** 获取safari版本号 */
  getSafariVersion() {
    const ua = navigator.userAgent.toLowerCase();
    const s = ua.match(/version\/([\d.]+).*safari/);
    return s ? s[1] : '0';
  },
  /** 是否为Chrome浏览器 */
  isChrome() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('chrome') > -1 && ua.indexOf('edg') < 0 && ua.indexOf('opr') < 0;
  },
  /** 是否为火狐浏览器 */
  isFireFox() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('firefox') > -1;
  },
  /** 是否为ie浏览器 */
  isIE() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('msie') > -1 || ua.indexOf('trident') > -1;
  },
  /** 是否为QQ内嵌浏览器 */
  isQQ() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('qq') > -1 && ua.indexOf('mqqbrowser') < 0;
  },
  /** 是否为QQ浏览器 */
  isQQInstalled() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('mqqbrowser') > -1;
  },
  /** 是否为WX浏览器 */
  isWx() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('micromessenger') > -1;
  },
  /** 是否为DingTalk */
  isDingTalk() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('dingtalk') > -1;
  },
  /** 是否为百度 */
  isBAIDU() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('baidu') > -1;
  },
  /** 是否为UC */
  isUC() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('ucbrowser') > -1;
  },
  /** 是否为华为自带浏览器 */
  isHUAWEI() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('huaweibrowser') > -1;
  },
  /** 是否为VIVO自带浏览器 */
  isVIVO() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('vivobrowser') > -1;
  },
  /** 是否为OPPO自带浏览器 */
  isOPPO() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('heytapbrowser') > -1;
  },
  /** 是否为小米自带浏览器 */
  isXIAOMI() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('miuibrowser') > -1;
  },

  /** 是否为 Mac端 safari 17 或者 iOS端 safari 15 以下版本使用videoId的用户 */
  unableSnapshot(videoSrc: string) {
    return !this.isClient()
      && videoSrc.startsWith('blob')
      && ((this.validateOS() === 'Mac'
        && this.isSafari()
        && +this.getSafariVersion().split('.')[0] < 17)
        || (this.validateOS() === 'iOS'
          && this.isSafari()
          && +this.getSafariVersion().split('.')[0] < 15)
      );
  },

  /**
   *  登录
   */
  login() {
    const { REACT_APP_LOGINURL } = process.env;
    const paramOrgId = this.getSearchParam()?.orgId || 0;
    const url = window.location.href.replace(/&token=[^&]+/g, ''); // 把带的token去掉，因为登录后会拼新的token
    const loginUrl = `${REACT_APP_LOGINURL}/user/authCenter?pure=1&auth=1&language=cn&organizationId=${paramOrgId}&from=${encodeURIComponent(url)}`;
    window.location.href = loginUrl;
  },

  /**
  *  退出登录
  */
  logout() {
    localStorage.removeItem('vod_token');
    this.login();
  },

  /**
   * 判断是否为全屏状态
   */
  isFullScreen(): boolean {
    const doc = document as any;
    return !!(
      doc.fullscreen
      || doc.mozFullScreen
      || doc.webkitIsFullScreen
      || doc.webkitFullScreen
      || doc.msFullScreen
    );
  },

};
